module.exports = __webpack_public_path__ + "static/media/sass.b446ca5a.svg";